import script from "./CompaniesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompaniesList.vue?vue&type=script&setup=true&lang=ts"

import "./CompaniesList.vue?vue&type=style&index=0&id=7f5f4608&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f5f4608"]])

export default __exports__